import { useSetAtom } from 'jotai';
import modularPdpAtom from './modularPdpAtom';
const useSetModularPdp = () => {
  const setModularPdp = useSetAtom(modularPdpAtom);
  return setModularPdp;
};
export default useSetModularPdp;